<template>
  <section class="container">
    <Card data-image="https://pwa.asfarma.com/res/aksen.png">
      <h1 slot="header">AksenFort</h1>
      <p slot="content">Musculo-skeletal system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/asfampisid.png">
      <h1 slot="header">Asfampisid</h1>
      <p slot="content">Antiinfectives</p>
    </Card>

    <Card data-image="https://pwa.asfarma.com/res/aldes.png">
      <h1 slot="header">Aldes</h1>
      <p slot="content">Respiratory system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/asformin.png">
      <h1 slot="header">Asformin</h1>
      <p slot="content">Alimentary tract and metabolism</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/artropem.png">
      <h1 slot="header">Artropem</h1>
      <p slot="content">Musculo-skeletal system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/aspan.png">
      <h1 slot="header">Aspan</h1>
      <p slot="content">Alimentary tract and metabolism</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/ateroks.png">
      <h1 slot="header">Ateroks</h1>
      <p slot="content">Cardiovascular system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/azinfexin.png">
      <h1 slot="header">Azinfexin</h1>
      <p slot="content">Antiinfectives</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/cardiva.png">
      <h1 slot="header">Cardiva</h1>
      <p slot="content">Cardiovascular system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/cefuro.png">
      <h1 slot="header">Cefuro</h1>
      <p slot="content">Antiinfectives</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/claverabid.png">
      <h1 slot="header">Clavera</h1>
      <p slot="content">Antiinfectives</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/conzepa.png">
      <h1 slot="header">Conzepa</h1>
      <p slot="content">Nervous System</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/co-ramas.png">
      <h1 slot="header">Co-ramas</h1>
      <p slot="content">Cardiovascular system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/dilutix.png">
      <h1 slot="header">Dilutix</h1>
      <p slot="content">Blood and blood forming organs</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/dorepam.png">
      <h1 slot="header">Dorepam</h1>
      <p slot="content">Nervouse system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/evalep.png">
      <h1 slot="header">Evalep</h1>
      <p slot="content">Nervouse system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/flutinex.png">
      <h1 slot="header">Flutinex</h1>
      <p slot="content">Respiratory system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/griphot.png">
      <h1 slot="header">Griphot</h1>
      <p slot="content">Respiratory system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/letromast.png">
      <h1 slot="header">Letromast</h1>
      <p slot="content">Antineoplastic and immunomodulating agents</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/libigran.png">
      <h1 slot="header">Libigran</h1>
      <p slot="content">Genito-urinary system and sex hormones</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/locogen.png">
      <h1 slot="header">Locogen</h1>
      <p slot="content">Musculo-skeletal system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/loroben.png">
      <h1 slot="header">Loroben</h1>
      <p slot="content">Alimentary tract and metabolism</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/lucamont.png">
      <h1 slot="header">Lucamont</h1>
      <p slot="content">Respiratory system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/meflocid.png">
      <h1 slot="header">Meflocid</h1>
      <p slot="content">Antiinfectives</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/megavit.png">
      <h1 slot="header">Megavit</h1>
      <p slot="content">Alimentary tract and metabolism</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/mepril.png">
      <h1 slot="header">Mepril</h1>
      <p slot="content">Alimentary tract and metabolism</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/modipin.png">
      <h1 slot="header">Modipin</h1>
      <p slot="content">Cardiovascular system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/monex.png">
      <h1 slot="header">Monex</h1>
      <p slot="content">Respiratory system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/obea.png">
      <h1 slot="header">Obea</h1>
      <p slot="content">Antiinfectives</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/probilac.png">
      <h1 slot="header">Probilac</h1>
      <p slot="content">Alimentary tract and metabolism</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/progast.png">
      <h1 slot="header">Progast</h1>
      <p slot="content">Alimentary tract and metabolism</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/protecta.png">
      <h1 slot="header">Protecta</h1>
      <p slot="content">Musculo-skeletal system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/pulmoxol.png">
      <h1 slot="header">Pulmoxol</h1>
      <p slot="content">Respiratory system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/sarmax.png">
      <h1 slot="header">Sarmax</h1>
      <p slot="content">Vitamins and Minerals</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/terix.png">
      <h1 slot="header">Terix</h1>
      <p slot="content">Respiratory system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/tiberal.png">
      <h1 slot="header">Tiberal</h1>
      <p slot="content">Genito-urinary system and sex hormones</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/udex.png">
      <h1 slot="header">Udex</h1>
      <p slot="content">Alimentary tract and metabolism</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/urfocin.png">
      <h1 slot="header">Urfocin</h1>
      <p slot="content">Antiinfectives</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/zefeksal.png">
      <h1 slot="header">Zefeksal</h1>
      <p slot="content">Respiratory system</p>
    </Card>
    <Card data-image="https://pwa.asfarma.com/res/zeralgo.png">
      <h1 slot="header">Zeralgo</h1>
      <p slot="content">Musculo-skeletal system</p>
    </Card>
  </section>
</template>

<script>
import Card from "@/components/Card";
export default {
  components: {
    Card
  }
};
</script>
<style scoped>
.container {
  padding: 10px 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  box-sizing: unset;
}
</style>
